import { Injectable } from '@angular/core'
import { Subject } from 'rxjs'

@Injectable({ providedIn: 'root' })
export class HotkeysService {
  keydown$ = new Subject<KeyboardEvent>()
  keypress$ = new Subject<KeyboardEvent>()
  keyup$ = new Subject<KeyboardEvent>()

  constructor () {
    this.bindEvent('keydown')
    this.bindEvent('keypress')
    this.bindEvent('keyup')
  }

  bindEvent (eventType: string): void {
    document.addEventListener(eventType, (jsEvent: KeyboardEvent) => {
      if (!document.activeElement) {
        return
      }
      if (eventType === 'keyup' && jsEvent.key === ' ' && (document.activeElement.tagName === 'BUTTON' || document.activeElement.tagName === 'A')) {
        // prevent space key from activating buttons and links
        jsEvent.preventDefault()
        jsEvent.stopPropagation()
      }
      if (document.querySelector('input:focus:not([type=range])') || document.querySelector('textarea:focus')) {
        return
      }
      this[`${eventType}$`].next(jsEvent)
    })
  }
}
